/**
 * Registro controlado de ícones: nome semântico → classes do FontAwesome Free 6.
 * Use sempre por `app-icon` (`<app-icon nome="excluir" />`); para um ícone novo, adicione aqui.
 */
export const ICONES = {
  'fechar': 'fa-solid fa-xmark',
  'check': 'fa-solid fa-check',
  'menos': 'fa-solid fa-minus',
  'chevron-baixo': 'fa-solid fa-chevron-down',
  'chevron-cima': 'fa-solid fa-chevron-up',
  'chevron-esquerda': 'fa-solid fa-chevron-left',
  'chevron-direita': 'fa-solid fa-chevron-right',
  'chevrons-esquerda': 'fa-solid fa-angles-left',
  'chevrons-direita': 'fa-solid fa-angles-right',
  'pesquisar': 'fa-solid fa-magnifying-glass',
  'filtro': 'fa-solid fa-filter',
  'adicionar': 'fa-solid fa-plus',
  'editar': 'fa-solid fa-pen',
  'excluir': 'fa-solid fa-trash-can',
  'salvar': 'fa-solid fa-floppy-disk',
  'download': 'fa-solid fa-download',
  'copiar': 'fa-regular fa-copy',
  'mais-opcoes': 'fa-solid fa-ellipsis-vertical',
  'alerta': 'fa-solid fa-circle-exclamation',
  'aviso': 'fa-solid fa-triangle-exclamation',
  'info': 'fa-solid fa-circle-info',
  'sucesso': 'fa-solid fa-circle-check',
  'carregando': 'fa-solid fa-circle-notch',
  'caixa-vazia': 'fa-solid fa-inbox',
  'visivel': 'fa-regular fa-eye',
  'oculto': 'fa-regular fa-eye-slash',
  'inicio': 'fa-solid fa-house',
  'usuario': 'fa-regular fa-user',
  'usuarios': 'fa-solid fa-users',
  'local': 'fa-solid fa-location-dot',
  'calendario': 'fa-regular fa-calendar-days',
  'relogio': 'fa-regular fa-clock',
  'menu': 'fa-solid fa-bars',
  'sair': 'fa-solid fa-right-from-bracket',
  'configuracoes': 'fa-solid fa-gear',
  'tema': 'fa-solid fa-circle-half-stroke',
  'sol': 'fa-regular fa-sun',
  'lua': 'fa-regular fa-moon',
  'monitor': 'fa-solid fa-desktop',
  'chave': 'fa-solid fa-key',
  'bandeira': 'fa-solid fa-flag',
  'link-externo': 'fa-solid fa-arrow-up-right-from-square',
  'erro': 'fa-solid fa-circle-xmark',
  'play': 'fa-solid fa-play',
  'parar': 'fa-solid fa-stop',
  'colunas': 'fa-solid fa-table-columns',
  'usuario-adicionar': 'fa-solid fa-user-plus',
  'presencial': 'fa-solid fa-map-location',
  'restaurar': 'fa-solid fa-rotate-left',
  'rascunho': 'fa-solid fa-pencil',
  'cancelado': 'fa-solid fa-ban',
  'dashboard': 'fa-solid fa-chart-line',
  'cadastros': 'fa-solid fa-file-pen',
  'financeiro': 'fa-solid fa-file-invoice-dollar',
  'marketing': 'fa-solid fa-ranking-star',
  'servicos': 'fa-solid fa-screwdriver-wrench',
  'suporte': 'fa-solid fa-headset',
  'notificacoes': 'fa-solid fa-bell',
  'atualizar': 'fa-solid fa-arrows-rotate',
  'escritorio': 'fa-solid fa-building',
  'inativo': 'fa-solid fa-circle-minus',
  'celular': 'fa-solid fa-mobile-screen',
  'remate': 'fa-solid fa-gavel',
  'versoes': 'fa-solid fa-code-branch',
  'parceiros': 'fa-solid fa-handshake',
  'lista': 'fa-solid fa-list',
  'calculadora': 'fa-solid fa-calculator',
  'tarifas': 'fa-solid fa-tags',
  'tv': 'fa-solid fa-tv',
  'dna': 'fa-solid fa-dna',
  'calendario-vazio': 'fa-regular fa-calendar-xmark',
  'cabanha': 'fa-solid fa-wheat-awn',
  'transmissora': 'fa-solid fa-tower-broadcast',
} as const satisfies Record<string, string>;

export type IconeNome = keyof typeof ICONES;
